import { Gpu } from '@typings';
import {
  ensureArray,
  getFormattedGpuMake,
  getFormattedMemory,
  isNumber,
} from '@utils';

import { Render } from '@components';

type Model = Gpu.Profile;

type Props = {
  className?: string;
  models: Model | Model[];
};

export const GpuModels = ({ className, models }: Props) => {
  const gpuModels = ensureArray(models);

  const makeGpuModel = ({
    gpuQuantity,
    gpuMake,
    gpuModelName,
    gpuMemory,
  }: Model) => {
    if (!gpuQuantity) {
      return null;
    }

    const memory = isNumber(gpuMemory)
      ? `(${getFormattedMemory(gpuMemory)})`
      : '';

    return `${gpuQuantity} x ${
      gpuModelName ?? getFormattedGpuMake(gpuMake)
    } ${memory}`;
  };

  return (
    <Render if={gpuModels}>
      <p className={className}>
        {gpuModels.map(makeGpuModel).filter(Boolean).join(', ')}
      </p>
    </Render>
  );
};
